import { render, staticRenderFns } from "./Declaracion.vue?vue&type=template&id=c7d4c3ae&"
import script from "./Declaracion.vue?vue&type=script&lang=js&"
export * from "./Declaracion.vue?vue&type=script&lang=js&"
import style0 from "./Declaracion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports